import { Config } from "@configs/Config";
import { User } from "@contexts/Auth";

const Cdn  = {
  getUrl(...args: any[]): string {
   return Config.URL_CDN_BASE + '/' + args.join('/');
  },
  getProductImageUrl(ean: string, nameIndustry: string): string {
    return nameIndustry ? Config.URL_CDN_BASE + `/${nameIndustry.toUpperCase()}/${ean}.jpg` : "";
  }
}


export default Cdn 